export class Timer {
	constructor( {
		             duration,
		             onProgress,
	             } ) {
		this.duration = duration;
		this.onProgress = onProgress;

		this.elapsedMillis = 0;
		this.running = false;
		this.timerId = null;
	}

	start() {
		if ( !this.running ) {
			let previousTime = Date.now();
			const step = () => {
				const nowTime = Date.now();
				this.elapsedMillis += nowTime - previousTime;
				previousTime = nowTime;

				let progress = this.getProgress();
				if ( progress >= 1 ) {
					this.pause();
				} else {
					this?.onProgress( progress );
					this.timerId = requestAnimationFrame( step );
				}
			};
			this.timerId = requestAnimationFrame( step );
			this.running = true;
		}
	}

	pause() {
		cancelAnimationFrame( this.timerId );
		this.running = false;

		this?.onProgress( this.getProgress() );
	}

	setProgress( progress ) {
		if ( progress < 0 ) {
			progress = 0;
		} else if ( progress > 1 ) {
			progress = 1;
		}
		this.elapsedMillis = progress * this.duration;

		this?.onProgress( this.getProgress() );
	}

	setProgressAnimated( progress, finishCallback = () => {
	} ) {
		const animationDuration = 500;
		const start = Date.now();
		const from = this.getProgress();
		const to = progress;

		const animate = () => {
			let elapsedTimeInPercent = Math.min( (Date.now() - start) / animationDuration, 1 );
			const sine = easeOutSine( elapsedTimeInPercent );
			this.setProgress( from * (1 - sine) + to * sine );

			if ( elapsedTimeInPercent < 1 ) {
				requestAnimationFrame( animate );
			} else {
				finishCallback?.();
			}
		};
		requestAnimationFrame( animate );
	}

	getProgress() {
		const progress = this.elapsedMillis / this.duration;
		return (progress > 1) ? 1 : progress;
	}
}

function easeOutSine( x ) {
	return Math.sin( (x * Math.PI) / 2 );
}
